<template>
  <Drawer :title="form.name" :visible="visible" :before-close="close" width="480px">
    <template v-slot:default>
      <div class="main">
        <div class="content">
          <div class="content_group">
            <div class="content_item">
              <div class="content_item_title">id</div>
              <div class="content_item_message">{{ form.id }}</div>
            </div>
            <div class="content_item">
              <div class="content_item_title">模版名称</div>
              <div class="content_item_message">{{ form.name }}</div>
            </div>
            <div class="content_item">
              <div class="content_item_title">更新人</div>
              <div class="content_item_message">{{ form.update_by }}</div>
            </div>
            <div class="content_item">
              <div class="content_item_title">更新时间</div>
              <div class="content_item_message">
                {{ dealTime(form.update_time) }}
              </div>
            </div>
            <div class="content_item">
              <div class="content_item_title">脱敏规则</div>
            </div>
            <div @click.stop="openJsonEdit()" style="width: 500px">
              <div class="json-editor">
                {{ form.desensitize_rule }}
              </div>
              <div class="tips">(点击进入详情)</div>
            </div>
            <div class="content_item">
              <div class="content_item_title">同步对象表</div>
              <div class="content_item_message">
                <el-tag v-for="(item, index) in form.sync_objects" :key="index">
                  {{ item }}
                </el-tag>
              </div>
            </div>
          </div>
        </div>
      </div>
      <json-edit
        v-if="showJson"
        type="view"
        :show-json="showJson"
        :json="jsonData"
        title="发布的流程配置"
        @cancel="showJson = false"
      />
    </template>
    <template v-slot:footer>
      <el-button class="drawer-footer-btn" @click="close">关闭</el-button>
      <el-button class="drawer-footer-btn" @click="edit" v-if="updateManage_sandboxTemplate_edit">
        编辑
      </el-button>
    </template>
  </Drawer>
</template>

<script>
import Drawer from '@/components/drawer';
import jsonEdit from '@/components/jsonEdit/index.vue';
import { isoToTimestamp, formattedDate } from '../utils/index';
// import _ from 'lodash';
export default {
  name: 'SandBoxItem',
  components: { Drawer, jsonEdit },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
    operateType: {
      type: String,
      default: 'add',
    },
    jurisdiction: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        name: '',
        sandbox_type: '',
        sandbox_tmpl_id: '',
        desc: '',
      },
      jsonData: {},
      showJson: false,
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        if (this.row.id) {
          this.$request({
            url: this.$api.getSandboxTemplate,
            data: {
              id: Number(this.row.id),
            },
          })
            .then((res) => {
              this.form = res.data;
              this.jsonData = this.form.desensitize_rule;
            })
            .catch((err) => {
              console.log('%c Line:115 🌶 err', 'color:#ea7e5c', err);
              this.form = {
                name: '',
                sandbox_type: '',
                sandbox_tmpl_id: '',
                desc: '',
              };
              this.jsonData = this.form.desensitize_rule;
            });
        }
      }
    },
  },
  methods: {
    dealTime(time) {
      time;
      console.log('%c Line:123 🌮 time', 'color:#f5ce50', time, isoToTimestamp(time));
      return formattedDate(isoToTimestamp(time));
    },
    openJsonEdit() {
      this.showJson = true;
    },
    close() {
      this.$emit('close');
    },
    edit() {
      this.$emit('close');
      this.$emit('editSandBoxTemplate', this.row);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';

.container {
  .row {
    margin-bottom: 8px;
    display: flex;
    .title {
      color: #98a2b2;
    }
    .text {
      flex: 1;
    }
  }
}
.drawer-footer-btn {
  margin-left: 8px;
}
.main {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  .content {
    display: flex;
    min-width: 448px;
    max-width: 688px;
    padding: 0px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
    &_group {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      align-self: stretch;
      .content_item {
        display: flex;
        max-width: 788px;
        padding: 4px 0px;
        // margin-top: 14px;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        &_title {
          display: flex;
          flex-direction: column;
          height: 22px;
          align-items: flex-start;
          align-self: stretch;
          color: #708091;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: var(--Family-, 'Microsoft YaHei UI');
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
        }
        &_message {
          display: flex;
          padding: var(--Spacing-2, 2px) var(--Spacing-0, 0px);
          align-items: flex-start;
          align-content: flex-start;
          gap: var(--Spacing-0, 0px) var(--Spacing-8, 8px);
          align-self: stretch;
          flex-wrap: wrap;
          color: var(--Text-Neutral-default, #151b22);
          font-feature-settings: 'liga' off, 'clig' off;

          /* ToB 中文/T1 14px Regular(400)-正文 */
          font-family: 'Microsoft YaHei UI';
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 157.143% */
        }
      }
    }
  }
}
.json-editor {
  background: #e5eaf2;
  height: 200px;
  width: 100%;
  overflow-x: scroll;
  overflow-y: scroll;
  cursor: pointer;
  line-height: 32px;
}
</style>
